import { globalConstants, projectConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  allData: [],
  formData: {},
};
//Manipulating the state of admin portal based on actions and returning the state
export const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case projectConstants.GET_PROJECTS + SUCCESS:
      return { ...state, data: action.data };
    case projectConstants.GET_PROJECT_LIST + SUCCESS:
      return { ...state, allData: action.data };
    case projectConstants.GET_PROJECT_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    default:
      return state;
  }
};
